import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.jpg";
import { HashLink } from 'react-router-hash-link';
import "./Navbar.css";

const navLinks = [
  { to: "/", label: "Inicio" },
  { to: "/projects", label: "Proyectos" },
  { to: "/servicios", label: "Servicios" },
  { to: "/tegnologias", label: "Tecnologías" },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Scroll shadow
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Cerrar menu al navegar
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar-container">

        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="NexoCode Logo" />
          <span className="navbar-brand">
            <span className="navbar-brand-text">NexoCode</span><span className="navbar-dot">.</span>
          </span>
        </Link>

        {/* Desktop Menu */}
        <ul className="navbar-menu">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`navbar-link ${location.pathname === to ? "navbar-link--active" : ""}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA Desktop */}
        <HashLink smooth to="/#Contact" className="navbar-cta">
          Contratar
        </HashLink>

        {/* Hamburger */}
        <button
          className={`navbar-hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`navbar-mobile ${menuOpen ? "navbar-mobile--open" : ""}`}>
        <ul>
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`navbar-mobile-link ${location.pathname === to ? "active" : ""}`}
              >
                {label}
              </Link>
            </li>
          ))}
          <li>
            <HashLink smooth to="/#Contact" className="navbar-mobile-cta">
              Contratar →
            </HashLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
